import { useLensApp } from "../useLensApp.jsx";

export default function LensToggleSection() {
  const { lensEnabled, lastLens, lensTransition, actions } = useLensApp();
  const lastLabel = lastLens?.name || lastLens?.lensId || "No lens loaded yet";

  return (
    <section className="lens-toggle-section">
      <div className="section-heading-row">
        <div>
          <h3>Lens</h3>
          <div className="hint flush" title={lastLabel}>Last: {lastLabel}</div>
        </div>
        {lensTransition && <span className="mode-working">{lensTransition === "on" ? "Loading…" : "Turning off…"}</span>}
      </div>
      <div className="lens-toggle-picker" role="group" aria-label="Lens effect">
        <button
          type="button"
          className={lensEnabled ? "selected" : ""}
          aria-pressed={lensEnabled}
          disabled={Boolean(lensTransition) || (!lastLens && !lensEnabled)}
          onClick={() => actions.setLensEnabled(true).catch(actions.setError)}
        >
          <strong>On</strong>
          <span>Load last lens</span>
        </button>
        <button
          type="button"
          className={!lensEnabled ? "selected" : ""}
          aria-pressed={!lensEnabled}
          disabled={Boolean(lensTransition)}
          onClick={() => actions.setLensEnabled(false).catch(actions.setError)}
        >
          <strong>Off</strong>
          <span>Clear effect</span>
        </button>
      </div>
    </section>
  );
}
